import { pathOr } from 'ramda';

import { IGetComparisonDesktopResponse } from '../../repositories/offers-comparison/v2/get-comparison-desktop';
import { IOffer } from '../../types/offer';
import { IOfferDesktopSchema } from '../../repositories/offers-comparison/entities/offer/OfferDesktopSchema';
import { transformComparisonNewbuilding } from './transformComparisonNewbuilding';
import { transformComparisonImages } from './transformComparisonImages';
import { transformComparisonFields } from './transformComparisonFields';
import { transformComparisonContacts } from './transformComparisonContacts';

export function transformComparisonOffers(response: IGetComparisonDesktopResponse): IOffer[] | null {
  if (!response.offers.length) {
    return null;
  }

  return response.offers.map((offer: IOfferDesktopSchema): IOffer => {
    return {
      /** Аналитика **/
      analytics: offer.analytics,
      /** Площади объявления **/
      area: offer.area,
      /** Количество балконов и лоджий **/
      balconies: pathOr(null, ['balconies'], offer),
      /** Год постройки **/
      buildYear: pathOr(null, ['buildYear'], offer),
      /** Застройщик **/
      builder: offer.builder,
      /** Категория **/
      category: offer.category,
      /** Новостройка или вторичка **/
      categoryName: pathOr(null, ['categoryName'], offer),
      /** Высота потолков, м **/
      ceilingHeight: pathOr(null, ['ceilingHeight'], offer),
      /** Контакты **/
      contacts: transformComparisonContacts(offer),
      /** Тип сделки **/
      dealType: offer.dealType,
      /** Список непустых строк таблицы с атрибутами объявления (для оптимизации фронта) **/
      fields: transformComparisonFields(offer),
      /** Этаж **/
      floor: offer.floor,
      /** Гео **/
      geo: offer.geo,
      /** ID **/
      id: offer.id,
      /** Изображения **/
      images: transformComparisonImages(offer),
      /** В избранном ли объявление у пользователя **/
      isFavorite: offer.isFavorite,
      /** Лифты **/
      lifts: pathOr(null, ['lifts'], offer),
      /** Возможна ли ипотека **/
      mortgage: pathOr(null, ['mortgage'], offer),
      /** ЖК **/
      newbuilding: transformComparisonNewbuilding(offer),
      /** Корпус ЖК **/
      newbuildingHouse: offer.newbuildingHouse,
      /** Тип объявления **/
      offerType: offer.offerType,
      /** Цена **/
      price: offer.price,
      /** Опубликовано ли объявление **/
      published: offer.published,
      /** Тип ремонта **/
      repairType: pathOr(null, ['repairType'], offer),
      /** Заголовок ('2-комн. апарт., 111,9 м², 9/10') **/
      title: offer.title,
      /** Ссылка на 3D-тур vr net **/
      tourUrl: offer.tourUrl,
      /** Url карточки **/
      url: offer.url,
      /** Санузел **/
      wc: pathOr(null, ['wc'], offer),
      /** Вид из окон **/
      windowsView: offer.windowsView,
    };
  });
}
